import React, { useState, useEffect, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";

const JobCardDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const server_folder = localStorage.getItem("server_folder");
  const server_url = localStorage.getItem("server_url");
  const grage_upi_id = localStorage.getItem("grage_upi_id");
  const grage_id = localStorage.getItem("grage_id");
  const grage_name = localStorage.getItem("grage_name");
  const [shareLoading, setShareLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [stopRemark, setStopRemark] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("1");
  const [serviceReminder, setServiceReminder] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [currentItem, setCurrentItem] = useState({
    description: "",
    qty: "",
    rate: "",
    gst: "0",
    amount: "",
  });
  // Suggestion states
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  // Debounce timer
  const [debounceTimer, setDebounceTimer] = useState(null);
  // GST options
  const gstOptions = [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "18", label: "18%" },
  ];
  // Reminder options
  const reminderOptions = [
    { value: "", label: "Skip" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
  ];
  // Payment options
  const paymentOptions = [
    { value: "1", label: "Paid" },
    { value: "2", label: "Unpaid" },
  ];

  useEffect(() => {
    fetchVehicleDetails();
  }, [id]);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  const fetchVehicleDetails = async () => {
    try {
      setLoading(true);
      const form = new FormData();
      form.append("company_id", "2");
      form.append("customer_id", "");
      form.append("vehicle_entry_grage_id", localStorage.getItem("grage_id"));
      form.append("from_date", "");
      form.append("to_date", "");
      form.append("vehicle_entry_id", id);
      const response = await axios.post(
        `${server_url}vehicle_history.php`,
        form,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      const res = response.data;
      if (res.status == "1" && res.result.length > 0) {
        const details = res.result[0];
        setVehicleDetails(details);
        // Set payment status from existing data
        if (details.payment_status) {
          setPaymentStatus(details.payment_status);
        }
      } else {
        setVehicleDetails(null);
        toast.error("Vehicle details not found");
      }
    } catch (err) {
      console.error("fetchVehicleDetails error:", err);
      toast.error("Failed to load vehicle details");
    } finally {
      setLoading(false);
    }
  };

  const handleStopService = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("vehicle_entry_id", id);
      formData.append("vehicle_exit_remark", stopRemark);
      formData.append("payment_status", paymentStatus);
      if (serviceReminder) {
        formData.append("service_reminder", serviceReminder);
      }

      const response = await axios.post(
        `${server_url}vehicle_out.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status == "1") {
        toast.success("Service stopped successfully!");
        fetchVehicleDetails();
      } else {
        toast.error(response.data.error || "Failed to stop service");
      }
    } catch (error) {
      console.error("Stop service error:", error);
      toast.error("Unable to stop service. Please try again.");
    } finally {
      setLoading(false);
      setShowConfirm(false);
      setStopRemark("");
      setPaymentStatus("1");
      setServiceReminder("");
    }
  };

  const handleUpdatePayment = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("vehicle_entry_id", id);
      formData.append("payment_status", paymentStatus);

      const response = await axios.post(
        `${server_url}update_payment_reminder.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status == "1") {
        toast.success("Payment status updated successfully!");
        fetchVehicleDetails();
        setShowPaymentModal(false);
      } else {
        toast.error(response.data.error || "Failed to update payment status");
      }
    } catch (error) {
      console.error("Update payment error:", error);
      toast.error("Unable to update payment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Rest of your existing functions remain the same...
  const openAddItem = () => {
    setEditingItem(null);
    setCurrentItem({
      description: "",
      qty: "",
      rate: "",
      gst: "0",
      amount: "",
    });
    setSuggestions([]);
    setShowSuggestions(false);
    setShowItemModal(true);
  };

  const openEditItem = (item, index) => {
    setEditingItem({ ...item, index });
    setCurrentItem({
      description: item.vehicle_entry_detail_description,
      qty: item.vehicle_entry_detail_qty,
      rate: item.vehicle_entry_detail_rate,
      gst: item.vehicle_entry_detail_gst,
      amount: item.vehicle_entry_detail_amt,
    });
    setSuggestions([]);
    setShowSuggestions(false);
    setShowItemModal(true);
  };

  // Calculate amount when qty, rate or gst changes
  useEffect(() => {
    if (showItemModal) {
      const qty = parseFloat(currentItem.qty) || 0;
      const rate = parseFloat(currentItem.rate) || 0;
      const gst = parseFloat(currentItem.gst) || 0;
      const baseAmount = qty * rate;
      const gstAmount = (baseAmount * gst) / 100;
      const totalAmount = baseAmount + gstAmount;
      setCurrentItem((prev) => ({
        ...prev,
        amount: totalAmount.toFixed(2),
      }));
    }
  }, [currentItem.qty, currentItem.rate, currentItem.gst, showItemModal]);

  const handleSaveItem = async () => {
    if (
      !currentItem.description.trim() ||
      !currentItem.qty ||
      !currentItem.rate ||
      !currentItem.gst
    ) {
      toast.error("Please fill all required fields");
      return;
    }
    const updatedItems = [...(vehicleDetails.service_items || [])];
    if (editingItem) {
      updatedItems[editingItem.index] = {
        ...updatedItems[editingItem.index],
        vehicle_entry_detail_description: currentItem.description,
        vehicle_entry_detail_qty: currentItem.qty,
        vehicle_entry_detail_rate: currentItem.rate,
        vehicle_entry_detail_gst: currentItem.gst,
        vehicle_entry_detail_amt: currentItem.amount,
      };
    } else {
      const newItem = {
        vehicle_entry_detail_id: "",
        vehicle_entry_detail_description: currentItem.description,
        vehicle_entry_detail_qty: currentItem.qty,
        vehicle_entry_detail_rate: currentItem.rate,
        vehicle_entry_detail_gst: currentItem.gst,
        vehicle_entry_detail_amt: currentItem.amount,
      };
      updatedItems.push(newItem);
    }
    const updatedVehicleDetails = {
      ...vehicleDetails,
      service_items: updatedItems,
    };
    setVehicleDetails(updatedVehicleDetails);
    await updateItemsToServer(updatedVehicleDetails);
    setShowItemModal(false);
    toast.success(
      editingItem ? "Item updated successfully!" : "Item added successfully!"
    );
  };

  const confirmRemoveItem = (index) => {
    setItemToDelete(index);
    setShowDeleteConfirm(true);
  };

  const handleRemoveItem = async () => {
    const index = itemToDelete;
    const updatedItems = vehicleDetails.service_items.filter(
      (_, i) => i !== index
    );
    const updatedVehicleDetails = {
      ...vehicleDetails,
      service_items: updatedItems,
    };
    setVehicleDetails(updatedVehicleDetails);
    setShowDeleteConfirm(false);
    setItemToDelete(null);
    await updateItemsToServer(updatedVehicleDetails);
    toast.success("Item removed successfully!");
  };

  const updateItemsToServer = async (vehicleData) => {
    if (!vehicleData?.service_items) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("vehicle_entry_id", id);
      formData.append("company_id", "2");
      formData.append("customer_id", vehicleData.customer_id);
      formData.append("vehicle_id", vehicleData.vehicle_id);
      formData.append(
        "vehicle_entry_grage_id",
        localStorage.getItem("grage_id")
      );
      formData.append(
        "vehicle_entry_total_amt",
        calculateTotals(vehicleData.service_items).finalTotal
      );
      formData.append(
        "vehicle_entry_remark",
        vehicleData.vehicle_entry_remark || ""
      );
      vehicleData.service_items.forEach((item, index) => {
        formData.append(
          "vehicle_entry_detail_id[]",
          item.vehicle_entry_detail_id || ""
        );
        formData.append(
          "vehicle_entry_detail_description[]",
          item.vehicle_entry_detail_description
        );
        formData.append(
          "vehicle_entry_detail_qty[]",
          item.vehicle_entry_detail_qty
        );
        formData.append(
          "vehicle_entry_detail_rate[]",
          item.vehicle_entry_detail_rate
        );
        formData.append(
          "vehicle_entry_detail_gst[]",
          item.vehicle_entry_detail_gst
        );
        formData.append(
          "vehicle_entry_detail_amt[]",
          item.vehicle_entry_detail_amt
        );
      });
      const response = await axios.post(
        `${server_url}vehicle_in_update.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.status !== "1") {
        toast.error(response.data.error || "Failed to update items");
        fetchVehicleDetails();
      }
    } catch (error) {
      console.error("Update items error:", error);
      toast.error("Unable to update items. Please try again.");
      fetchVehicleDetails();
    } finally {
      setLoading(false);
    }
  };

  const isVehicleActive = (vehicle) => {
    return !vehicle.vehicle_entry_out_date && !vehicle.vehicle_entry_out_time;
  };

  const calculateTotals = (items = vehicleDetails?.service_items) => {
    if (!items) return { subtotal: 0, totalGST: 0, finalTotal: 0 };
    let subtotal = 0;
    let totalGST = 0;
    items.forEach((item) => {
      const rate = parseFloat(item.vehicle_entry_detail_rate) || 0;
      const qty = parseFloat(item.vehicle_entry_detail_qty) || 0;
      const gst = parseFloat(item.vehicle_entry_detail_gst) || 0;
      const itemTotal = rate * qty;
      const itemGST = (itemTotal * gst) / 100;
      subtotal += itemTotal;
      totalGST += itemGST;
    });
    const finalTotal = subtotal + totalGST;
    return {
      subtotal: subtotal.toFixed(2),
      totalGST: totalGST.toFixed(2),
      finalTotal: finalTotal.toFixed(2),
    };
  };

  const handleShareEstimate = async () => {
    if (!vehicleDetails) return;
    setShareLoading(true);
    try {
      const token = btoa(
        `${id}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      );
      const estimateLink = `${
        window.location.origin + server_folder
      }/estimate/${id}?token=${token}`;
      const customerName = vehicleDetails.customer_name || "Customer";
      const vehicleNo = vehicleDetails.vehicle_reg_no || "Vehicle";
      const totalAmount = calculateTotals().finalTotal;
      const message = `Hello ${customerName}! 👋
Your service estimate for *${vehicleNo}* is ready.

🔧 *Service Estimate Summary*
- *Vehicle:* ${vehicleNo}
- *Total Estimate:* ₹${totalAmount}
- *View detailed estimate:* ${estimateLink}

This estimate includes all parts and labor charges.
Please contact us on ${localStorage.getItem("garageLoginNumber")} for any query.

Thank you,
*${localStorage.getItem("grage_name") || "MydigiGarage"}*`;

      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/+91${vehicleDetails.customer_mobile}?text=${encodedMessage}`;
      window.open(whatsappUrl, "_blank");
      toast.success("Estimate shared via WhatsApp!");
    } catch (error) {
      console.error("Share estimate error:", error);
      toast.error("Failed to share estimate");
    } finally {
      setShareLoading(false);
    }
  };

  if (loading && !vehicleDetails) {
    return (
      <div
        className="mobile-app-layout"
        style={{ marginTop: "auto", marginBottom: "auto" }}
      >
        <center>
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <div>Loading vehicle details...</div>
          </div>
        </center>
      </div>
    );
  }

  if (!vehicleDetails) {
    return (
      <div className="mobile-app-layout">
        <div className="empty-state">
          <div className="empty-icon">⚠️</div>
          <div className="empty-title">Vehicle Not Found</div>
          <button onClick={() => navigate(-1)} className="action-btn">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const isActive = isVehicleActive(vehicleDetails);
  const totals = calculateTotals();
  const hasServiceItems =
    vehicleDetails.service_items && vehicleDetails.service_items.length > 0;

  return (
    <div className="mobile-app-layout">
      {/* Stop Service Modal */}
      {showConfirm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Stop Service</h3>
              <button
                onClick={() => {
                  setShowConfirm(false);
                  setStopRemark("");
                  setServiceReminder("");
                }}
                className="close-btn"
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="">Remark</label>
                <textarea
                  value={stopRemark}
                  onChange={(e) => setStopRemark(e.target.value)}
                  placeholder="Enter reason for stopping service..."
                  rows="3"
                  className="remark-textarea"
                />
              </div>

              <div className="form-group">
                <label className="required">Payment Status</label>
                <div className="radio-options">
                  {paymentOptions.map((option) => (
                    <label key={option.value} className="radio-label" style={{ width: "30%" }}>
                      <input
                        type="radio"
                        name="paymentStatus"
                        value={option.value}
                        checked={paymentStatus === option.value}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                        required
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label style={{ width: "100%" }}>
                  Service Reminder In Month
                </label>
                <div
                  className="radio-options"
                  style={{ display: "ruby", overflowX: "auto" }}
                >
                  {reminderOptions.map((option) => (
                    <label
                      key={option.value}
                      className="radio-label"
                      style={{ width: "22%", marginLeft: "10px" }}
                    >
                      <input
                        type="radio"
                        name="serviceReminder"
                        value={option.value}
                        checked={serviceReminder === option.value}
                        onChange={(e) => setServiceReminder(e.target.value)}
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  setShowConfirm(false);
                  setStopRemark("");
                  setServiceReminder("");
                }}
                className="btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleStopService}
                className="btn-primary"
              
              >
                {loading ? "Stopping..." : "Stop Service"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Update Payment Modal */}
      {showPaymentModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Update Payment Status</h3>
              <button
                onClick={() => setShowPaymentModal(false)}
                className="close-btn"
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="required">Payment Status</label>
                <div className="radio-options">
                  {paymentOptions.map((option) => (
                    <label key={option.value} className="radio-label">
                      <input
                        type="radio"
                        name="paymentStatus"
                        value={option.value}
                        checked={paymentStatus === option.value}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                        required
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => setShowPaymentModal(false)}
                className="btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleUpdatePayment}
                className="btn-primary"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Payment"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Item Modal */}
      {showItemModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editingItem ? "Edit Service Item" : "Add Service Item"}</h3>
              <button
                onClick={() => setShowItemModal(false)}
                className="close-btn"
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="required">Description</label>
                <input
                  type="text"
                  value={currentItem.description}
                  onChange={(e) =>
                    setCurrentItem({
                      ...currentItem,
                      description: e.target.value,
                    })
                  }
                  placeholder="Enter item description"
                />
              </div>
              <div className="form-group">
                <label className="required">Quantity</label>
                <input
                  type="number"
                  value={currentItem.qty}
                  onChange={(e) =>
                    setCurrentItem({ ...currentItem, qty: e.target.value })
                  }
                  placeholder="Qty"
                  min="1"
                />
              </div>
              <div className="form-group">
                <label className="required">Rate</label>
                <input
                  type="number"
                  value={currentItem.rate}
                  onChange={(e) =>
                    setCurrentItem({ ...currentItem, rate: e.target.value })
                  }
                  placeholder="Rate"
                  min="0"
                  step="0.01"
                />
              </div>
              <div className="form-group">
                <label>GST %</label>
                <div className="gst-options">
                  {gstOptions.map((option) => (
                    <label key={option.value} className="radio-label">
                      <input
                        type="radio"
                        name="gst"
                        value={option.value}
                        checked={currentItem.gst == option.value}
                        onChange={(e) =>
                          setCurrentItem({
                            ...currentItem,
                            gst: e.target.value,
                          })
                        }
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label>Amount</label>
                <input
                  type="text"
                  value={`₹${currentItem.amount}`}
                  readOnly
                  className="amount-display"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => setShowItemModal(false)}
                className="btn-secondary"
              >
                Cancel
              </button>
              <button onClick={handleSaveItem} className="btn-primary">
                {editingItem ? "Update Item" : "Add Item"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="modal-overlay">
          <div className="modal-content delete-confirm-modal">
            <div className="modal-header">
              <h3>Confirm Delete</h3>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to remove this item?</p>
              <div className="delete-actions">
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="btn-secondary"
                >
                  Cancel
                </button>
                <button onClick={handleRemoveItem} className="btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className="content-area jobcardetailstop"
        style={{ paddingTop: "10px" }}
      >
        <div className="invoice-card">
          {/* Header */}
          <div className="invoice-header">
            <div className="invoice-meta">
              <div className="meta-row">
                <span>#{vehicleDetails.vehicle_entry_no}</span>
                <span>
                  {vehicleDetails.vehicle_entry_out_date ? (
                    <span className="payment-status">
                      Payment:{" "}
                      {vehicleDetails.payment_status === "1"
                        ? "✅ Paid"
                        : "❌ Unpaid"}
                    </span>
                  ) : (
                    <img
                      src={server_folder + "/img/live.gif"}
                      style={{ float: "right", height: "20px" }}
                      alt="Live"
                    />
                  )}
                </span>
              </div>
              <div className="meta-row">
                <span>In Date:</span>
                <span>
                  {vehicleDetails.vehicle_entry_in_date}{" "}
                  {vehicleDetails.vehicle_entry_in_time}
                </span>
              </div>
              {vehicleDetails.vehicle_entry_out_date && (
                <div className="meta-row">
                  <span>Exit Date:</span>
                  <span>
                    {vehicleDetails.vehicle_entry_out_date}{" "}
                    {vehicleDetails.vehicle_entry_out_time}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Customer & Vehicle Info */}
          <div className="info-section">
            <div className="info-column">
              <h4>Customer Information</h4>
              <div className="info-item">
                <span>Name:</span>
                <strong>{vehicleDetails.customer_name || "N/A"}</strong>
              </div>
              <div className="info-item">
                <span>Mobile:</span>
                <a
                  href={`tel:${vehicleDetails.customer_mobile}`}
                  className="phone-link"
                >
                  {vehicleDetails.customer_mobile || "N/A"}
                </a>
              </div>
              <div className="info-item">
                <span>Vehicle:</span>
                <strong>{vehicleDetails.vehicle_reg_no || "N/A"}</strong>
              </div>
            </div>
          </div>

          {/* Service Items Table */}
          <div className="items-section">
            <div className="section-header">
              <h4 style={{ float: "left", marginTop: "6px", fontSize: "20px" }}>
                Service Items
              </h4>
              <button onClick={openAddItem} className="add-item-btn">
                <i className="fas fa-plus"></i>
                Add Item
              </button>
            </div>
            {hasServiceItems ? (
              <div className="items-table-container">
                <br />
                <br />
                <table
                  className="items-table"
                  style={{
                    minWidth: "-webkit-fill-available",
                    textAlign: "left",
                    marginTop: "8px",
                  }}
                >
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>GST</th>
                      <th>Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleDetails.service_items.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => openEditItem(item, index)}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {item.vehicle_entry_detail_description}
                        </td>
                        <td>{item.vehicle_entry_detail_qty}</td>
                        <td>₹{item.vehicle_entry_detail_rate}</td>
                        <td>
                          {item.vehicle_entry_detail_gst > 0
                            ? item.vehicle_entry_detail_gst + "%"
                            : "-"}
                        </td>
                        <td>₹{item.vehicle_entry_detail_amt}</td>
                        <td>
                          <button
                            onClick={() => confirmRemoveItem(index)}
                            className="remove-btn"
                            title="Remove"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="no-items">
                <p>No service items added yet.</p>
              </div>
            )}
          </div>

          {/* Invoice Summary */}
          <div className="summary-section">
            <h4>Invoice Summary</h4>
            <div className="summary-row">
              <span>Subtotal:</span>
              <span>₹{totals.subtotal}</span>
            </div>
            <div className="summary-row">
              <span>Total GST:</span>
              <span>₹{totals.totalGST}</span>
            </div>
            <div className="summary-row total">
              <span>Final Total:</span>
              <strong>₹{totals.finalTotal}</strong>
            </div>
          </div>

          {/* Remarks */}
          {vehicleDetails.vehicle_entry_remark ||
          vehicleDetails.vehicle_exit_remark ? (
            <div className="remarks-section">
              <h4>Remarks</h4>
              <p style={{ textAlign: "left" }}>
                In: {vehicleDetails.vehicle_entry_remark}
              </p>
              {vehicleDetails.vehicle_exit_remark && (
                <p style={{ textAlign: "left" }}>
                  Out: {vehicleDetails.vehicle_exit_remark}
                </p>
              )}
            </div>
          ) : (
            ""
          )}

          {/* Action Buttons */}
          <table style={{ width: "100%" }}>
            <tr>
              <td style={{ width: "50%" }}>
                {isActive ? (
                  <div className="stop-service-section">
                    <button
                      onClick={() => setShowConfirm(true)}
                      className="stop-service-btn"
                    >
                      <i className="fas fa-stop-circle"></i>
                      Stop Service
                    </button>
                  </div>
                ) : (
                  <div className="update-payment-section">
                    <button
                      onClick={() => setShowPaymentModal(true)}
                      className="update-payment-btn"
                    >
                      <i className="fas fa-edit"></i>
                      Update Payment
                    </button>
                  </div>
                )}
              </td>
              <td style={{ float: "right" }}>
                <div className="floating-share-btn-container">
                  <button
                    onClick={handleShareEstimate}
                    className="floating-share-btn"
                    disabled={shareLoading}
                  >
                    <i className="fas fa-share"></i>
                    {shareLoading ? "Sharing..." : "Share Estimate"}
                  </button>
                </div>
              </td>
            </tr>
          </table>

          {grage_upi_id && (
            <div className="upi-body">
              <div className="qr-container">
                <div className="qr-code">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
                      `upi://pay?pa=${grage_upi_id}&pn=${encodeURIComponent(
                        grage_name || "Garage"
                      )}&am=${totals.finalTotal}&cu=INR`
                    )}`}
                    alt="UPI QR Code"
                    className="qr-image"
                  />
                </div>
                <div className="upi-details">
                  <p className="upi-amount">Amount: ₹{totals.finalTotal}</p>
                  <p className="upi-id">UPI ID: {grage_upi_id}</p>
                  <p className="upi-name">Name: {grage_name}</p>
                  <p className="upi-instruction">Scan & Pay with any UPI App</p>
                </div>
              </div>
              <p className="upi-note">
                Ensure your UPI app has a linked bank account.
              </p>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .modal-header h3 {
          font-size: 1.25rem;
        }
        .floating-share-btn {
          background: #25d366;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: 8px;
          gap: 8px;
          transition: all 0.3s ease;
        }
        .floating-share-btn:hover:not(:disabled) {
          background: #128c7e;
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
        }
        .floating-share-btn:disabled {
          background: #9ae6b4;
          cursor: not-allowed;
          transform: none;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .update-payment-btn {
          background: #4299e1;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
        }
        .update-payment-btn:hover {
          background: #3182ce;
          transform: translateY(-1px);
        }
        .stop-service-btn {
          background: #e53e3e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
        }
        .stop-service-btn:hover {
          background: #c53030;
          transform: translateY(-1px);
        }
        textarea {
          border-radius: 10px;
          background: white;
          border: 1px solid gray;
          padding: 15px;
          width: 100%;
        }
        .mobile-app-layout {
          min-height: 100vh;
          background: #f8fafc;
        }
        .radio-options {
          display: -webkit-box;
          flex-direction: column;
          gap: 10px;
        }
        .radio-label {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .radio-label:hover {
          border-color: #0352a1;
        }
        .radio-label input[type="radio"]:checked + span {
          color: #0352a1;
          font-weight: 600;
        }
        .payment-status {
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 4px;
          background: #f0fff4;
          color: #22543d;
          font-size: 14px;
        }
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }
        .modal-content {
          background: white;
          border-radius: 16px;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
        }
        .delete-confirm-modal {
          max-width: 400px;
        }
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #e2e8f0;
        }
        .modal-header h3 {
          margin: 0;
          color: #2d3748;
        }
        .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          color: #718096;
          cursor: pointer;
          padding: 4px;
        }
        .modal-body {
          padding: 5px 10px 0px 10px;
        }
        .form-group {
          overflow-x: auto;
          display: flex;
          flex-direction: column;
          text-align: left;
          margin-bottom: 10px;
        }
        .form-group label {
          width: 30%;
          font-weight: 600;
          color: #4a5568;
          font-size: 14px;
          margin-bottom: 4px;
        }
        .form-group label.required::after {
          content: " *";
          color: #e53e3e;
        }
        .form-group input {
          padding: 12px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 16px;
        }
        .form-group input:focus {
          outline: none;
          border-color: #0352a1;
        }
        .gst-options {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
        .amount-display {
          background: #f7fafc;
          color: #2d3748;
          font-weight: 600;
        }
        .modal-footer {
          display: flex;
          gap: 5px;
          padding: 10px;
          border-top: 1px solid #e2e8f0;
        }
        .delete-actions {
          display: flex;
          gap: 12px;
          margin-top: 20px;
        }
        .btn-secondary {
          background: #e2e8f0;
          color: #4a5568;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        .btn-primary {
          background: #0352a1;
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        .btn-danger {
          background: #dc2626;
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          flex: 1;
        }
        .content-area {
          padding: 16px;
        }
        .invoice-card {
          background: white;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        .invoice-header {
          border-bottom: 2px solid #e2e8f0;
          padding-bottom: 5px;
          margin-bottom: 5px;
        }
        .invoice-meta {
          display: grid;
          gap: 8px;
        }
        .meta-row {
          display: flex;
          justify-content: space-between;
          color: #718096;
          font-size: 14px;
        }
        .info-section {
          background: #f0fff4;
          border: 1px solid #9ae6b4;
          border-radius: 8px;
          padding: 10px;
          margin-bottom: 10px;
        }
        .info-column h4 {
          margin: 0 0 5px 0;
          color: #2d3748;
          font-size: 16px;
        }
        .info-item {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid #f1f1f1;
        }
        .info-item:last-child {
          border-bottom: none;
        }
        .phone-link {
          color: #0352a1;
          text-decoration: none;
        }
        .phone-link:hover {
          text-decoration: underline;
        }
        .section-header {
          display: unset;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }
        .section-header h4 {
          margin: 0;
          color: #2d3748;
          font-size: 16px;
        }
        .add-item-btn {
          background: #48bb78;
          color: white;
          border: none;
          padding: 10px 16px;
          border-radius: 6px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 14px;
          transition: all 0.3s ease;
          float: right;
        }
        .add-item-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .items-section {
          margin-bottom: 10px;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .items-table th {
          background: #0352a1;
          color: white;
          padding: 12px 8px;
          text-align: left;
          font-weight: 600;
          border: none;
          white-space: nowrap;
        }
        .items-table td {
          padding: 10px 8px;
          border-bottom: 1px solid #e2e8f0;
          border-right: 1px solid #e2e8f0;
        }
        .items-table td:last-child {
          border-right: none;
        }
        .items-table tr:nth-child(even) {
          background-color: #f8f9fa;
        }
        .items-table tr:hover {
          background-color: #edf2f7;
        }
        .remove-btn {
          background: none;
          border: none;
          padding: 6px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #e53e3e;
        }
        .remove-btn:hover {
          background: #fed7d7;
        }
        .no-items {
          text-align: center;
          padding: 40px 20px;
          color: #718096;
          border: 2px dashed #e2e8f0;
          border-radius: 8px;
        }
        .no-items p {
          margin: 0 0 16px 0;
        }
        .summary-section {
          background: #f0fff4;
          border: 1px solid #9ae6b4;
          border-radius: 8px;
          padding: 10px;
          margin-bottom: 10px;
        }
        .summary-section h4 {
          margin: 0 0 12px 0;
          color: #22543d;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 6px 0;
          color: #2d3748;
        }
        .summary-row.total {
          border-top: 1px solid #9ae6b4;
          padding-top: 12px;
          margin-top: 8px;
          font-size: 16px;
        }
        .remarks-section {
          background: #fffaf0;
          border: 1px solid #fbd38d;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 20px;
        }
        .remarks-section h4 {
          margin: 0 0 8px 0;
          color: #744210;
        }
        .remarks-section p {
          margin: 0;
          color: #744210;
          font-style: italic;
        }
        .loading-state,
        .empty-state {
          text-align: center;
          padding: 80px 20px;
          color: #718096;
        }
        .loading-spinner {
          width: 32px;
          height: 32px;
          border: 3px solid #e2e8f0;
          border-top: 3px solid #0352a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 16px;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        .empty-icon {
          font-size: 48px;
          margin-bottom: 16px;
        }
        .empty-title {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
          margin-bottom: 8px;
        }
        .action-btn {
          background: #0352a1;
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.3s ease;
        }
        .action-btn:hover {
          background: #3182ce;
        }
        @media (max-width: 768px) {
          .content-area {
            padding: 0px 12px;
          }
          .invoice-card {
            padding: 16px;
          }
          .modal-content {
            margin: 0;
            border-radius: 16px 16px;
            max-height: 80vh;
          }
          .items-table {
            font-size: 12px;
            min-width: 400px;
          }
        }

        .upi-body {
          margin-top: 10px;
          padding: 16px;
          background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
          border-radius: 12px;
          border: 1px solid #0ea5e9;
          box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);
        }

        .qr-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-bottom: 4px;
        }

        .qr-code {
          display: flex;
          justify-content: center;
          align-items: center;
          background: white;
          padding: 8px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .qr-image {
          max-width: 150px;
          max-height: 150px;
          border: none;
          border-radius: 4px;
        }

        .upi-details {
          text-align: center;
          color: #0c4a6e;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
        }

        .upi-amount {
          font-size: 18px;
          font-weight: bold;
          color: #0369a1;
          margin: 0 0 0px 0;
        }

        .upi-id,
        .upi-name {
          font-size: 14px;
          font-weight: 500;
          margin: 4px 0;
          word-break: break-all;
        }

        .upi-instruction {
          font-size: 12px;
          color: #475569;
          margin: 4px 0;
          font-style: italic;
        }

        .upi-note {
          font-size: 11px;
          color: #64748b;
          margin: 0;
          background: rgba(255, 255, 255, 0.7);
          padding: 6px 10px;
          border-radius: 6px;
          border-left: 3px solid #0ea5e9;
        }

        @media (min-width: 768px) {
          .qr-container {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }

          .qr-code {
            flex: 0 0 auto;
          }

          .upi-details {
            flex: 1;
            text-align: left;
            padding-left: 16px;
          }

          .upi-amount {
            font-size: 20px;
          }
        }

        @media (max-width: 480px) {
          .upi-body {
            padding: 10px;
          }

          .qr-image {
            max-width: 120px;
            max-height: 120px;
          }
        }
      `}</style>
    </div>
  );
};

export default JobCardDetails;
